<template>
  <transition name="modal-fade">
    <div 
      v-if="modalState.isOpen" 
      class="custom-modal-overlay" 
      @click.self="cancel"
      @keydown.esc="cancel"
      tabindex="-1"
    >
      <div class="custom-modal-card" role="dialog" aria-modal="true">
        <!-- Close icon button -->
        <button class="modal-close-btn" @click="cancel" title="Yopish">
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
          </svg>
        </button>

        <!-- Icon Section -->
        <div class="modal-icon-wrapper" :class="iconClass">
          <svg v-if="modalState.type === 'danger'" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <polyline points="3 6 5 6 21 6"></polyline>
            <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
            <line x1="10" y1="11" x2="10" y2="17"></line>
            <line x1="14" y1="11" x2="14" y2="17"></line>
          </svg>
          <svg v-else-if="modalState.type === 'warning'" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"></path>
            <line x1="12" y1="9" x2="12" y2="13"></line>
            <line x1="12" y1="17" x2="12.01" y2="17"></line>
          </svg>
          <svg v-else xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <circle cx="12" cy="12" r="10"></circle>
            <line x1="12" y1="16" x2="12" y2="12"></line>
            <line x1="12" y1="8" x2="12.01" y2="8"></line>
          </svg>
        </div>

        <!-- Content -->
        <div class="modal-text-content">
          <h3 class="modal-title">{{ modalState.title }}</h3>
          <p class="modal-message">{{ modalState.message }}</p>
        </div>

        <!-- Actions -->
        <div class="modal-actions">
          <button class="btn-cancel" @click="cancel">
            {{ modalState.cancelText }}
          </button>
          <button class="btn-confirm" :class="confirmBtnClass" @click="confirm">
            {{ modalState.confirmText }}
          </button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { modalState, handleConfirm, handleCancel } from "../utils/confirmModal";

export default {
  name: "ModernConfirmModal",
  setup() {
    return {
      modalState
    };
  },
  computed: {
    iconClass() {
      return `icon-${this.modalState.type || 'danger'}`;
    },
    confirmBtnClass() {
      return `btn-${this.modalState.type || 'danger'}`;
    }
  },
  methods: {
    confirm() {
      handleConfirm();
    },
    cancel() {
      handleCancel();
    }
  }
};
</script>

<style scoped>
.custom-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(15, 23, 42, 0.7);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 99999;
  padding: 16px;
}

.custom-modal-card {
  position: relative;
  width: 100%;
  max-width: 440px;
  background: #ffffff;
  border-radius: 20px;
  padding: 32px 28px 24px 28px;
  box-shadow: 0 25px 50px -12px rgba(15, 23, 42, 0.35), 0 0 0 1px rgba(0, 0, 0, 0.05);
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  transform-origin: center;
}

.modal-close-btn {
  position: absolute;
  top: 16px;
  right: 16px;
  background: transparent;
  border: none;
  color: #94a3b8;
  cursor: pointer;
  padding: 6px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
}

.modal-close-btn:hover {
  background-color: #f1f5f9;
  color: #334155;
}

.modal-icon-wrapper {
  width: 64px;
  height: 64px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
  transition: transform 0.3s ease;
}

.modal-icon-wrapper.icon-danger {
  background: #fef2f2;
  color: #ef4444;
  box-shadow: 0 0 0 8px #fff5f5;
}

.modal-icon-wrapper.icon-warning {
  background: #fffbeb;
  color: #f59e0b;
  box-shadow: 0 0 0 8px #fefdf7;
}

.modal-icon-wrapper.icon-info {
  background: #eff6ff;
  color: #3b82f6;
  box-shadow: 0 0 0 8px #f8faff;
}

.modal-text-content {
  margin-bottom: 24px;
}

.modal-title {
  font-size: 19px;
  font-weight: 700;
  color: #0f172a;
  margin: 0 0 8px 0;
  letter-spacing: -0.3px;
}

.modal-message {
  font-size: 14px;
  line-height: 1.55;
  color: #64748b;
  margin: 0;
}

.modal-actions {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  width: 100%;
}

.btn-cancel {
  flex: 1;
  padding: 12px 18px;
  font-size: 14px;
  font-weight: 600;
  color: #475569;
  background-color: #f1f5f9;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.btn-cancel:hover {
  background-color: #e2e8f0;
  color: #1e293b;
}

.btn-confirm {
  flex: 1;
  padding: 12px 18px;
  font-size: 14px;
  font-weight: 600;
  color: #ffffff;
  border: none;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.btn-confirm.btn-danger {
  background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);
  box-shadow: 0 4px 14px rgba(239, 68, 68, 0.35);
}

.btn-confirm.btn-danger:hover {
  background: linear-gradient(135deg, #dc2626 0%, #b91c1c 100%);
  transform: translateY(-1px);
  box-shadow: 0 6px 18px rgba(239, 68, 68, 0.45);
}

.btn-confirm.btn-danger:active {
  transform: translateY(0);
}

/* Animations */
.modal-fade-enter-active,
.modal-fade-leave-active {
  transition: opacity 0.25s ease;
}

.modal-fade-enter-from,
.modal-fade-leave-to {
  opacity: 0;
}

.modal-fade-enter-active .custom-modal-card {
  animation: modal-pop 0.25s cubic-bezier(0.16, 1, 0.3, 1);
}

.modal-fade-leave-active .custom-modal-card {
  animation: modal-pop 0.2s cubic-bezier(0.16, 1, 0.3, 1) reverse;
}

@keyframes modal-pop {
  0% {
    opacity: 0;
    transform: scale(0.92) translateY(8px);
  }
  100% {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}
</style>
